import React, { useContext } from 'react';

import useTranslations from '../../hooks/useTranslations';
import BackButton from '../BackButton';
import {
  ACTIVE_VIEW,
  AutomationsContex
} from '../engine/FormBuilderAutomationsEngine';
import { Container } from './FormBuilderStatusesView';
import styled from 'styled-components/macro';
import { SimpleFlexContainer } from '../layouts/ng-layouts/Containers';
import Button from '../Button';
import { ACTIVE_VIEW as SUB_ACTIVE_VIEW } from '../engine/FormBuilderCustomButtonsEngine';
import DeleteButtonDialog from '../../internal-components/GeneralDialog';
import FormBuilderCustomButtonCardEngine from '../engine/FormBuilderCustomButtonCardEngine';
import Colors from '../../internal-components/Colors';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

const TitleContainer = styled.div`
  display: flex;
`;
const H2 = styled.h2``;

const AddCustomButtonBtn = styled(Button)`
  && {
    align-self: baseline;
  }
`;

const Headers = styled.div`
  display: flex;
  padding: 0.8rem;
  h3 {
    width: 20%;
  }
`;
const H3 = styled.h3`
  color: ${Colors.DARK_GREY};
  margin: 0;
  ${({ $width }) => $width && `width: ${$width} !important;`}
`;

const NewBtnPositioner = styled.div`
  margin-left: auto;
  align-self: center;
`;

const FormBuilderCustomButtonsView = props => {
  const { setActiveView } = useContext(AutomationsContex);
  const t = useTranslations();
  return (
    <>
      <Container>
        <SimpleFlexContainer>
          <TitleContainer>
            <BackButton
              onClick={() => setActiveView(ACTIVE_VIEW.AUTOMATIONS_LIST)}
            />
            <H2>{t('customButtons.list.title')} </H2>
            <NewBtnPositioner>
              <Button
                onClick={() =>
                  props.setActiveView(SUB_ACTIVE_VIEW.BUTTON_WIZARD)
                }
              >
                {t('customButtons.add')}
              </Button>
            </NewBtnPositioner>
          </TitleContainer>

          <Headers>
            <H3 $width="5%"></H3>
            <H3 $width="30%">
              {t('customButtons.list.table.columnHeader.btn')}
            </H3>
            <H3>{t('customButtons.list.table.columnHeader.dsplyOn')}</H3>
            <H3>{t('customButtons.list.table.columnHeader.dsply4')}</H3>
            <H3>{t('customButtons.list.table.columnHeader.clicked')}</H3>
            <H3 $width="15%"></H3>
          </Headers>
          <DragDropContext onDragEnd={props.onDragEnd}>
            <Droppable droppableId="droppable">
              {provided => (
                <div>
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {props.buttons.map(btn => (
                      <FormBuilderCustomButtonCardEngine
                        key={btn.id}
                        buttonData={btn}
                      />
                    ))}
                  </div>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </SimpleFlexContainer>
      </Container>
      <DeleteButtonDialog
        open={props.isDeleteDialogOpen}
        title="dialog.title.areYouSure"
        content="customButtons.delete.dialog.content"
        variant="delete"
        handleConfirm={() => {
          props.setBtn2Delete(props.btnIdInDeleteReviewRef.current);
          props.setIsDeleteDialogOpen(false);
        }}
        handleClose={() => props.setIsDeleteDialogOpen(false)}
      />
    </>
  );
};

export default FormBuilderCustomButtonsView;
